import { RouteType } from "types/RouteType";
import QCInspectionWorkflowStore from "./QCInspectionWorkflowStore";

const QCInspectionWorkflowRoute: RouteType = {
  name: "QC Inspection Workflow",
  path: "/workflows/qc-inspection",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Sand Moisture Test",
      component: () => import("./QCInspectionWorkflowHeader"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./QCInspectionWorkflow"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    // Initialize store if not exists
    if (!rootStore.qcInspectionWorkflowStore) {
      rootStore.qcInspectionWorkflowStore = new QCInspectionWorkflowStore(rootStore);
    }
    // Reset to clean state when entering
    const store = rootStore.qcInspectionWorkflowStore as QCInspectionWorkflowStore;
    store.reset();
    return true;
  },
};

export default QCInspectionWorkflowRoute;
